// extracted by mini-css-extract-plugin
export default {"external":"aN2Ms9","wrapper":"bN2Ms9","security":"cN2Ms9","buttonWrapper":"dN2Ms9"};